import React, { useState, useEffect } from "react";
import { exportToExcel } from "../../utils/exportToExcel";
import { useTheme } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";
import { isDarkTheme } from "../../helpers/darkTint";

const STORAGE_KEY = "reportPrintData";

const ReportPrintPage = () => {
  const theme = useTheme();
  const isDark = isDarkTheme(theme);
  const [printData, setPrintData] = useState(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        setPrintData(JSON.parse(raw));
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      console.error("Erro ao ler dados:", e);
    }
  }, []);

  if (!printData) {
    return <div style={{ padding: 20 }}>{i18n.t("printPage.noData")}</div>;
  }

  // Folha de impressão: no tema escuro mantém o papel branco e força o texto escuro
  const sheetStyle = isDark
    ? { background: "#fff", color: "rgba(0, 0, 0, 0.87)", minHeight: "100vh", boxSizing: "border-box" }
    : {};

  return (
    <div style={{ padding: 20, fontFamily: "Arial, sans-serif", ...sheetStyle }}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          table { page-break-inside: auto !important; break-inside: auto !important; }
          thead { display: table-header-group; }
          tr { page-break-inside: avoid; break-inside: avoid; }
        }
      `}</style>

      <div className="no-print" style={{ marginBottom: 16, display: "flex", gap: 8 }}>
        <button
          onClick={() => window.print()}
          style={{
            padding: "8px 16px",
            background: "#00aeef",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          {i18n.t("common.print")}
        </button>
        <button
          onClick={() => {
            const rows = printData.rows.map((row) => {
              const obj = {};
              printData.headers.forEach((h, i) => {
                obj[h] = row[i] ?? "";
              });
              return obj;
            });
            const fallbackName = i18n.t("printPage.fileName");
            const filename = (printData.title || fallbackName)
              .toLowerCase()
              .replace(/\s+/g, "-")
              .replace(/[^a-z0-9-]/g, "");
            exportToExcel(rows, filename || fallbackName, i18n.t("printPage.sheetName"));
          }}
          style={{
            padding: "8px 16px",
            background: "#27ae60",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          {i18n.t("common.exportExcel")}
        </button>
      </div>

      <h2 style={{ margin: "0 0 4px" }}>{printData.title}</h2>
      <p style={{ margin: "0 0 16px", color: "#555", fontSize: 12, borderBottom: "1px solid #ddd", paddingBottom: 8 }}>
        {printData.subtitle}
      </p>

      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
        <thead>
          <tr>
            {printData.headers.map((h, i) => (
              <th key={i} style={{ border: "1px solid #ccc", padding: "5px 8px", background: "#f0f0f0", textAlign: "left" }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {printData.rows.map((row, i) => (
            <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
              {row.map((cell, j) => (
                <td key={j} style={{ border: "1px solid #ccc", padding: "5px 8px" }}>
                  {cell ?? ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportPrintPage;
